module.exports = __webpack_public_path__ + "img/star-icon.b8ee7a1d.svg";